import { Tooltip, Switch } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { faAdd, faFilter, faHistory, faMapLocation, faPrint } from "@fortawesome/free-solid-svg-icons";

//ASSETS
import iconTalhao from '../../../../../../assets/img/iconTalhao.svg';
import iconTalhaoSubArea from '../../../../../../assets/img/iconSubArea.svg';

//APP
import { tipoCard } from "../ListaAtividades/meta";
import { localConfig } from "../../../../../../Configs/localConfig";
import { tooltipCadatrar } from "../../meta";
import { Item__Talhao, ItemPropriedades } from "../../../../../../services/atividades/GET";

//COMPONENTS
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import { Render } from "../../../../../../Components/CustomUi/render";
import { Inline } from "../../../../../../Components/CustomUi/inline";
import { PopSelect } from "../../../../../../Components/CustomUi/PopSelect";
import { ModalPopOver } from "../../../../../../Components/CustomUi/modalPopOver";

//COMPONENTS IN PRINT SETTINGS
import { Imprimir } from "./imprimir";

//PROPS
interface Props {
    cod_propriedade_selecionada: number;
    setCod_propriedade_selecionada: React.Dispatch<React.SetStateAction<number>>;
    cod_talhao_selecionado: number;
    setCod_talhao_selecionado: React.Dispatch<React.SetStateAction<number>>;
    cod_subarea_selecionada: number;
    setCod_subarea_selecionada: React.Dispatch<React.SetStateAction<number>>;
    setArea_talhao_selecionado: React.Dispatch<React.SetStateAction<string>>;
    setArea_subarea_selecionada: React.Dispatch<React.SetStateAction<string>>;
    setOpen_historico: React.Dispatch<React.SetStateAction<boolean>>;
    setOpen_gaveta_avancado: React.Dispatch<React.SetStateAction<boolean>>;
    setOpen_drawer_cadastro: React.Dispatch<React.SetStateAction<boolean>>;
    /**lista de propriedade com os talhões (do cliente) */
    data_propriedades: ItemPropriedades[];
    /**loading do Select de propriedade */
    carregando_propriedades: boolean;
    /**lista de talhões da propriedade selecionada */
    lista_talhoes: Item__Talhao[];
    /**permisão para cadastrar atividade */
    permissao_alterar: boolean;
    /**ativa a animaçõa de loading ao alterar algum filtro */
    setTransition: Function;
    onPrint?: () => void;
    breakAvoid: boolean;
    setBreakAvoid: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean
}

export const Filtros: React.FC<Props> = ({ setCod_propriedade_selecionada, data_propriedades, carregando_propriedades,
    cod_propriedade_selecionada, setCod_talhao_selecionado, setArea_talhao_selecionado, lista_talhoes,
    cod_talhao_selecionado, setCod_subarea_selecionada, setArea_subarea_selecionada, cod_subarea_selecionada,
    setOpen_historico, setOpen_gaveta_avancado, permissao_alterar, setOpen_drawer_cadastro, setTransition,
    onPrint, breakAvoid, setBreakAvoid, loading
}) => {

    //CONST
    const { codSafra } = localConfig();

    //#region STATES
    //PROPRIEDADE
    const [nome_propriedade_selecionada_temp, setNome_propriedade_selecionada_temp] = useState<string>('');
    const [cod_propriedade_selecionada_temp, setCod_propriedade_selecionada_temp] = useState<number>(null);
    //TALHAO
    const [nome_talhao_selecionado_temp, setNome_talhao_selecionado_temp] = useState<string>('');
    const [cod_talhao_selecionado_temp, setCod_talhao_selecionado_temp] = useState<number>(null);
    const [area_talhao_selecionado_temp, setArea_talhao_selecionado_temp] = useState<string>('');
    //SUBAREA
    const [nome_subarea_selecionada_temp, setNome_subarea_selecionada_temp] = useState<string>('');
    const [cod_subarea_selecionada_temp, setCod_subarea_selecionada_temp] = useState<number>(null);
    const [area_subarea_selecionada_temp, setArea_subarea_selecionada_temp] = useState<string>('');
    const [open_print_settings, setOpen_print_settings] = useState<boolean>(false);

    //#region FILTRO PROPRIEDADE
    useEffect(() => {
        /**inicia a animação de transição*/
        setTransition(true);

        /**limpa os selct de talhão e subárea ao alterar propriedade */
        setNome_talhao_selecionado_temp('');
        setCod_talhao_selecionado_temp(null);
        setNome_subarea_selecionada_temp('');
        setCod_subarea_selecionada_temp(null);

        /**timeout para primeiro executar a animação do select e só depois aplicar o filtro nos cards. Isso é feito para melhorar a performanse e evitar lags */
        const time = setTimeout(() => {
            setCod_propriedade_selecionada(cod_propriedade_selecionada_temp);
        }, 260);

        /**limpa o timout da memória ao desmontar o componente */
        return (() => {
            clearTimeout(time);
        })
    }, [cod_propriedade_selecionada_temp]);

    //#region FILTRO TALHÃO
    useEffect(() => {
        /**inicia a animação de transição*/
        setTransition(true);

        /**limpa os selct de subárea ao alterar o talhão */
        setNome_subarea_selecionada_temp('');
        setCod_subarea_selecionada_temp(null);
        setArea_subarea_selecionada_temp('');

        /**timeout para primeiro executar a animação do select e só depois aplicar o filtro nos cards. Isso é feito para melhorar a performanse e evitar lags */
        const time = setTimeout(() => {
            setCod_talhao_selecionado(cod_talhao_selecionado_temp);
            setArea_talhao_selecionado(area_talhao_selecionado_temp);
        }, 260);

        /**limpa o timout da memória ao desmontar o componente */
        return (() => {
            clearTimeout(time);
        })
    }, [cod_talhao_selecionado_temp]);

    //#region FILTRO SUBÁREA
    useEffect(() => {
        /**inicia a animação de transição*/
        setTransition(true);

        /**timeout para primeiro executar a animação do select e só depois aplicar o filtro nos cards. Isso é feito para melhorar a performanse e evitar lags */
        const time = setTimeout(() => {
            setCod_subarea_selecionada(cod_subarea_selecionada_temp);
            setArea_subarea_selecionada(area_subarea_selecionada_temp);
        }, 260);

        /**limpa o timout da memória ao desmontar o componente */
        return (() => {
            clearTimeout(time);
        })
    }, [cod_subarea_selecionada_temp]);

    //#region LIMPAR CAMPOS
    useEffect(() => {
        /**limpa os filtros ao alterar safra. (via de regra ao limpar a propriedade os demais campos serão limpos automáticamente em outro useeffect) */
        setNome_propriedade_selecionada_temp('');
        setCod_propriedade_selecionada_temp(null);
    }, [codSafra])


    //#region APP
    return (
        <Inline style={{ marginTop: -10 }} alignItems="flex-end">
            <div style={{ width: '100%', display: 'flex', gap: 15, alignItems: 'center' }}>
                <PopSelect
                    label="Selecione a propriedade"
                    empty_placeholder="Nenhuma foi selecionada"
                    icon={faMapLocation}
                    value={nome_propriedade_selecionada_temp}
                    onChange={setNome_propriedade_selecionada_temp}
                    onChangeId={setCod_propriedade_selecionada_temp}
                    items={data_propriedades ?? []}
                    descricaoItem="nome"
                    idItem="cod"
                    loading={carregando_propriedades}
                    zIndex={10}
                />
                <Tooltip title={cod_propriedade_selecionada === null ? 'Selecione uma propriedade primeiramente' : undefined}><samp>
                    <PopSelect
                        label="Selecione o talhão"
                        empty_placeholder="Nenhum foi selecionado"
                        icon={iconTalhao}
                        value={nome_talhao_selecionado_temp}
                        onChange={setNome_talhao_selecionado_temp}
                        onChangeId={setCod_talhao_selecionado_temp}
                        onChangeExtra={setArea_talhao_selecionado_temp}
                        items={(lista_talhoes ?? []).filter(i => i?.cod_safra == codSafra && i.cod_talhao === null) ?? []}
                        iconList={["kml", "coordenadas"]}
                        descricaoItem="nome"
                        idItem="cod"
                        extraItem='area'
                        disabled={cod_propriedade_selecionada === null}
                        zIndex={9}
                    /></samp>
                </Tooltip>
                <Tooltip title={cod_talhao_selecionado === null
                    ? "Selecione um talhão primeiramente"
                    : ((lista_talhoes ?? []).filter(i => i?.cod_safra !== null && i.cod_talhao === cod_talhao_selecionado) ?? []).length === 0
                        ? <div><b>Esse talhão não possui subáreas cadastradas!</b> <br /> Para cadastrar uma subárea para o talhão, vá em <i><u>Propriedades</u></i> ⤏ <i><u>Subárea do talhão</u></i></div> : undefined}><samp>
                        <PopSelect
                            label="Subarea"
                            empty_placeholder="Nenhuma foi selecionada"
                            icon={iconTalhaoSubArea}
                            value={nome_subarea_selecionada_temp}
                            onChange={setNome_subarea_selecionada_temp}
                            onChangeId={setCod_subarea_selecionada_temp}
                            onChangeExtra={setArea_subarea_selecionada_temp}
                            items={(lista_talhoes ?? []).filter(i => i?.cod_safra !== null && i.cod_talhao === cod_talhao_selecionado) ?? []}
                            iconList={["kml", "coordenadas"]}
                            descricaoItem="nome"
                            idItem="cod"
                            extraItem='area'
                            disabled={cod_talhao_selecionado === null || ((lista_talhoes ?? []).filter(i => i?.cod_safra !== null && i.cod_talhao === cod_talhao_selecionado) ?? []).length === 0}
                            zIndex={8}
                        /></samp>
                </Tooltip>

            </div>

            <Render condition={tipoCard(cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada) === 'talhao'}>
                <Tooltip title="Histórico de modificações"><span>
                    <ButtonCustom
                        onClick={() => { setOpen_historico(true) }}
                        icon={<FontAwesomeIcon icon={faHistory} />}
                        type={'tertiary'}
                    />
                </span></Tooltip>
            </Render>


            <Tooltip title="Imprimir linha do tempo"><span>
                <ButtonCustom
                    onClick={() => setOpen_print_settings(true)}
                    icon={<FontAwesomeIcon icon={faPrint} />}
                    type={'secondary'}
                />
            </span></Tooltip>

            <Tooltip title="Filtrar por nome da atividade, tipo de operações ou intervalo de datas"><span>
                <ButtonCustom
                    onClick={() => { setOpen_gaveta_avancado(true) }}
                    icon={<FontAwesomeIcon icon={faFilter} />}
                    type={'secondary'}
                >
                    Filtro avançado
                </ButtonCustom>
            </span></Tooltip>

            <Tooltip color={!permissao_alterar ? 'rgba(255,165,0,0.97)' : undefined} title={tooltipCadatrar(cod_talhao_selecionado, permissao_alterar)}><span>
                <ButtonCustom
                    onClick={() => { setOpen_drawer_cadastro(true) }}
                    icon={<FontAwesomeIcon icon={faAdd} />}
                    disabled={cod_talhao_selecionado === null || cod_propriedade_selecionada === null || !permissao_alterar}
                >
                    Cadastrar
                </ButtonCustom>
            </span></Tooltip>

            <ModalPopOver
                title="Configurações da impressão"
                open={open_print_settings}
                onClose={() => setOpen_print_settings(false)}
                width={330}
                height="auto"
                top={100}
                right={180}
            >
                <Imprimir
                    breakAvoid={breakAvoid}
                    setBreakAvoid={setBreakAvoid}
                    setOpen_print_settings={setOpen_print_settings}
                    onPrint={onPrint}
                    loading={loading}
                />
            </ModalPopOver>

        </Inline>
    )
}